
function getVariantStyle(variant) {
  switch (variant) {
    case "featured":
      return {
        container: {
          borderTop: "6px solid #114c96",
          padding: "1rem",
        },
        title: {
          fontSize: "1.6rem",
          color: "#114c96",
        },
        subtitle: {
          fontSize: "1rem",
        },
      };

    case "news":
      return {
        container: {
          borderTop: "3px solid #114c96",
          background: "#f8fbff",
        },
        title: {
          fontSize: "1.2rem",
          color: "#114c96",
          textTransform: "uppercase",
        },
        subtitle: {
          fontSize: "0.9rem",
        },
      };

    default:
      return {
        container: {
          borderTop: "4px solid #114c96",
        },
        title: {
          fontSize: "1.3rem",
          color: "#114c96",
        },
        subtitle: {},
      };
  }
}

export default function PortalCard({
  title,
  subtitle,
  children,
  variant = "default", // "default" | "featured" | "news"
  style = {},
}) {
  const variantStyle = getVariantStyle(variant);

  return (
    <div style={{ ...baseCardStyle, ...variantStyle.container, ...style }}>
      {title && <h3 style={{ ...titleStyle, ...variantStyle.title }}>{title}</h3>}
      {subtitle && (
        <p style={{ ...subtitleStyle, ...variantStyle.subtitle }}>
          {subtitle}
        </p>
      )}
      <div>{children}</div>
    </div>
  );
}

const baseCardStyle = {
  background: "#f4f7fb",
  border: "1px solid #9bb7d7",
  borderRadius: "6px",
  padding: "1.25rem",
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
};

const titleStyle = {
  margin: "0 0 0.4rem 0",
  fontWeight: 700,
  letterSpacing: "0.02em",
};

const subtitleStyle = {
  margin: "0 0 1rem 0",
  color: "#42566f",
  lineHeight: 1.5,
};